var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"brand-logo",attrs:{"href":"javascript:void(0);"}},[_c('h3',{staticClass:"card-title font-weight-bold mb-1"},[_c('img',{staticClass:"width-10-per",attrs:{"src":`${_vm.publicPath}vaults-authlogo.png`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }